/* Keep privacy disclosures available on Klaviyo signup steps as forms render. */
(() => {
  'use strict';
  const marker = 'data-sip-signup-notices';
  const phaseOneForms = new Set([
    'klaviyo-form-WJ8vht', 'klaviyo-form-UPSRkS',
    'klaviyo-form-VitTkw', 'klaviyo-form-Yte8zf',
    'klaviyo-form-WfhXiT', 'klaviyo-form-YysnZw'
  ]);
  const phaseOneCopyBlocks = new Map([
  [
    "klaviyo-form-WJ8vht",
    "rich-text-01M4BG4CJZ7EY349EZ6QGTH2V2"
  ],
  [
    "klaviyo-form-VitTkw",
    "rich-text-01M4BMKJ57APF3W1FXWS5CDGKP"
  ],
  [
    "klaviyo-form-WfhXiT",
    "rich-text-01M4BN0GD7123YYXADH91D186C"
  ],
  [
    "klaviyo-form-UPSRkS",
    "rich-text-01M3ZQ4V7XFQJGGXCDKWHQC0W0"
  ],
  [
    "klaviyo-form-Yte8zf",
    "rich-text-01M3ZPFW2ZM9CJZKB8DJ9PYKZF"
  ],
  [
    "klaviyo-form-YysnZw",
    "rich-text-01M3ZMYDVQ0902QDVMQEZPXSH3"
  ]
]);

  function alignPhaseOneCopy(form) {
    const copyId = phaseOneCopyBlocks.get(form.getAttribute('data-testid'));
    if (!copyId) return;
    const copy = form.querySelector('#' + copyId);
    const paragraphs = copy
      ? Array.from(copy.querySelectorAll(':scope > p'))
      : Array.from(form.querySelectorAll('.klaviyo-form-richtext > h1 + p'));
    paragraphs.forEach((paragraph) => {
      const wrapper = getComputedStyle(paragraph.parentElement.parentElement);
      if (paragraph.querySelector('img') || !paragraph.textContent.trim()) return;
      paragraph.style.setProperty('margin-left', (20 - parseFloat(wrapper.paddingLeft)) + 'px', 'important');
      paragraph.style.setProperty('margin-right', (20 - parseFloat(wrapper.paddingRight)) + 'px', 'important');
    });
  }
  let scheduled = false;

  function addNotices() {
    scheduled = false;
    document.querySelectorAll('form.klaviyo-form').forEach((form) => {
      alignPhaseOneCopy(form);
      if (form.querySelector('[' + marker + ']')) return;
      const action = form.querySelector('button.klaviyo-form-button');
      if (!action) return;
      let branch = action;
      let column = action.parentElement;
      while (column && column !== form) {
        const layout = getComputedStyle(column);
        if (layout.display === 'flex' && layout.flexDirection === 'column') break;
        branch = column;
        column = column.parentElement;
      }
      if (!column || column === form) return;
      const isPhaseOne = phaseOneForms.has(form.getAttribute('data-testid'));
      const noticeTextColor = isPhaseOne ? '#fff' : '#333';
      const noticeBackground = isPhaseOne ? '#000' : '#fff';
      const notices = document.createElement('div');
      notices.setAttribute(marker, '');
      notices.style.cssText = 'display:block;width:100%;box-sizing:border-box;padding:8px ' + (isPhaseOne ? 20 : 12) + 'px;text-align:center;font:12px/1.5 Arial,sans-serif;color:' + noticeTextColor + ';background:' + noticeBackground + ';';
      const links = [
        ['California Privacy Notice', 'https://privacy.sparkleinpink.com/privacy-policy#california-privacy-notice'],
        ['Notice of Financial Incentive', 'https://privacy.sparkleinpink.com/privacy-policy#financial-incentive']
      ];
      links.forEach(([label, href], index) => {
        if (index) notices.appendChild(document.createTextNode(' · '));
        const link = document.createElement('a');
        link.textContent = label;
        link.href = href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.cssText = 'display:inline;color:' + noticeTextColor + ';text-decoration:underline;font:inherit;';
        notices.appendChild(link);
      });
      column.insertBefore(notices, branch);
    });
  }

  function start() {
    addNotices();
    new MutationObserver((records) => {
      const changedForm = records.some((record) =>
        record.target instanceof Element &&
        (record.target.closest('form.klaviyo-form') || Array.from(record.addedNodes).some((node) =>
          node instanceof Element && (node.matches('form.klaviyo-form') || node.querySelector('form.klaviyo-form'))
        ))
      );
      if (changedForm && !scheduled) {
        scheduled = true;
        requestAnimationFrame(addNotices);
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
